import { gql } from '@apollo/client'

export const CustomerJourneyFragment = gql`
  fragment CustomerJourney on CustomerJourney {
    id
    accountInStore
    appointmentBooked
    appointmentPrepForm
    appointmentPassed
    quoteApproved
    quoteCreated
    orderCreated
    orderCreatedWithDelivery
    orderPaid
    orderCancelled
    orderDelivered
  }
`

export const CustomerProjectStateFragment = gql`
  fragment CustomerProjectState on CustomerProjectState {
    id
    activeStatusMyProject
    activeStatusSalesTool
    favoriteProductsCompleted
    favoriteProductsUpdatedAt
    kitchenConfigurationsCompleted
    kitchenConfigurationsUpdatedAt
    kitchenDrawingsCompleted
    kitchenDrawingsUpdatedAt
    onboardingResultCompleted
    onboardingResultUpdatedAt
    ordersCompleted
    ordersUpdatedAt
    quotesCompleted
    quotesUpdatedAt
    accountCreated
    webAccountCreated
    appointmentCreated
    appointmentPrepFormCompleted
    appointmentCancelled
    quoteCreated
    quotePublished
    quoteApproved
    orderCreated
    orderCreatedWithDelivery
    rftCreated
    rftPublished
    rftApproved
    rftVtoAdded
    rftVtoApproved
    orderPaid
    orderPaidWithDelivery
    orderCancelled
    orderDelivered
  }
`

export const CustomerProfileFragment = gql`
  fragment CustomerProfile on CustomerProfile {
    houseName
    houseNumber
    addressLine1
    addressLine2
    addressLine3
    city
    region
    country
    email
    firstName
    lastName
    phoneNumber
    phoneNumber2
    postalCode
    title
  }
`

export const CustomerSettingsFragment = gql`
  fragment CustomerSettings on CustomerSettings {
    communicateOffersPerEmail
    communicateOffersPerPhone
    communicateOffersPerPost
    communicateOffersPerSms
    hasAgreedToTerms
    messagingEmailNotificationEnabled
  }
`

export const CustomerFragment = gql`
  ${CustomerProfileFragment}
  ${CustomerSettingsFragment}
  fragment Customer on Customer {
    id
    sapUserId
    inactive
    profile {
      ...CustomerProfile
    }
    settings {
      ...CustomerSettings
    }
  }
`
